import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShoppingCart, Product } from 'src/app/classes';

@Component({
  selector: 'app-shopping-cart-overview',
  templateUrl: './shopping-cart-overview.component.html',
  styleUrls: ['./shopping-cart-overview.component.css']
})
export class ShoppingCartOverviewComponent implements OnInit {

  _products: Product[] = [];
  set products(products: Product[]){
    this.setupPriceSum = 0;
    this.rentalPriceSum = 0;
    this.purchasePriceSum = 0;
    this._products = products;
    for(let product of products){
      if(typeof product.productsetupcost === 'number') this.setupPriceSum += product.productsetupcost;
      if(typeof product.productrentalcost === 'number') this.rentalPriceSum += product.productrentalcost;
      if(typeof product.productpurchasecost === 'number') this.purchasePriceSum += product.productpurchasecost;
    }
  }
  get products(): Product[] {
    return this._products;
  }

  setupPriceSum: number;
  rentalPriceSum: number;
  purchasePriceSum: number;

  constructor(
    private _ref: MatDialogRef<ShoppingCartOverviewComponent>,
    @Inject(MAT_DIALOG_DATA) public cart: ShoppingCart
  ) {

  }

  close(){
    this._ref.close(false);
  }

  confirmOrder(){
    this._ref.close(true);
  }

  ngOnInit(): void {
    if(this.cart){
      if(this.cart.products){
        this.products = this.cart.products;
      }
    }
  }

  removeItem(product: Product){
    let i = this.cart.products.indexOf(product);
    if(i > -1){
      this.cart.products.splice(i, 1);
      this.products = this.cart.products;
    }
  }

}
